import TLUsageType from "./pageComponents/PropertyUsageType";



export const tlComponents = {
  TLPropertyUsageType: TLUsageType,
};
